/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_3_1Inputs */

const en_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_3_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_3_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This site’s editor uses local file open/download; no shared editing flow is provided here.`)
};

const zh_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_3_1 = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_3_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`本站编辑器采用本地打开与下载文件的方式，未提供多人共同编辑流程。`)
};

/**
* | output |
* | --- |
* | "This site’s editor uses local file open/download; no shared editing flow is provided here." |
*
* @param {Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_3_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_3_1 = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_3_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Vs_Excel_Sections_0_Table_Rows_3_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_3_1(inputs)
	return zh_gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_3_1(inputs)
});
export { gc_search_guides_gridcraft_vs_excel_sections_0_table_rows_3_1 as "gc.search_guides.gridcraft_vs_excel.sections.0.table.rows.3.1" }